import { browserHasProAccess } from './browser-product-access.js';
import type { SchemaInput } from '../shared/schema-input.js';
import { hasProAccess, productAccessFromUser } from '../shared/plans.js';

const ZOOM_SCALING_STORAGE_KEY = 'zoomScalingEnabled';

interface EditorPreferencesDependencies {
  storage?: Pick<Storage, 'getItem' | 'setItem'>;
}

export function createEditorPreferences(
  getCurrentUser: () => SchemaInput,
  dependencies: EditorPreferencesDependencies = {},
) {
  function getStorage(): Pick<Storage, 'getItem' | 'setItem'> {
    return dependencies.storage ?? globalThis.localStorage;
  }

  function isZoomScalingEnabled(): boolean {
    try {
      return getStorage().getItem(ZOOM_SCALING_STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }

  function setZoomScalingEnabled(enabled: boolean): void {
    try {
      getStorage().setItem(ZOOM_SCALING_STORAGE_KEY, enabled ? 'true' : 'false');
    } catch {}
  }

  function isProUser(user: SchemaInput): boolean {
    return hasProAccess(productAccessFromUser(user)) || browserHasProAccess();
  }

  function getUserPlanForAnalytics(): 'anonymous' | 'paid_guest' | 'free' | 'pro' {
    const user = getCurrentUser();
    if (!user) return browserHasProAccess() ? 'paid_guest' : 'anonymous';
    return isProUser(user) ? 'pro' : 'free';
  }

  return {
    isZoomScalingEnabled,
    setZoomScalingEnabled,
    saveSideSnappingEnabled,
    isProUser,
    getUserPlanForAnalytics,
  };
}

export function readSideSnappingEnabled(): boolean {
  try { return globalThis.localStorage.getItem('sideSnappingEnabled') !== 'false'; }
  catch { return true; }
}

export function saveSideSnappingEnabled(enabled: boolean): void {
  try { globalThis.localStorage.setItem('sideSnappingEnabled', String(enabled)); }
  catch {}
}
